module.exports = __webpack_public_path__ + "static/media/catalogueImg11.04a28198.png";